import React from "react";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
// import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';

function PdfViewer({ url, show, setShow, placement }) {
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  function handleClose(e) {
    e.stopPropagation();
    setShow(false);
  }

  const getFileType = (src) => {
    const extension = src?.split('.').pop().toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
      return 'image';
    } else if (extension === 'pdf') {
      return 'pdf';
    }
    return 'unknown';
  };

  const fileType = getFileType(url);

  return (
    <>
      {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js"> */}
        <SlDrawer
          label="Document View"
          open={show}
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={handleClose}
          style={{'--size':'767px'}}
          placement={placement ? placement : 'start'}
        >
          <div className="file-preview">
            {fileType === 'image' && (
              <img src={url} alt="Preview" style={{ width: '100%', height: 'auto' }} />
            )}
            {fileType === 'pdf' && (
              <div>
                <embed src={url} type="application/pdf" style={{ width: '100%', height: '90vh' }} />
                {/* <Viewer fileUrl={url} defaultScale={SpecialZoomLevel.PageWidth} /> */}
              </div>
            )}
            {fileType === 'unknown' && <p>Unsupported file type</p>}
          </div>
        </SlDrawer>
      {/* </Worker> */}
    </>
  );
}

export default PdfViewer;
